import { DatePicker } from "ant-design-vue";
const { WeekPicker, MonthPicker, RangePicker, ...other } = DatePicker;
const YwDatePicker = {
	...other,
	name: "YwDatePicker",
	WeekPicker: {
		...WeekPicker,
		name: "YwWeekPicker",
	},
	MonthPicker: {
		...MonthPicker,
		name: "YwMonthPicker",
	},
	RangePicker: {
		...RangePicker,
		name: "YwRangePicker",
	},
};
YwDatePicker.install = function (Vue) {
	Vue.component(YwDatePicker.name, DatePicker);
	Vue.component(YwDatePicker.WeekPicker.name, WeekPicker);
	Vue.component(YwDatePicker.MonthPicker.name, MonthPicker);
	Vue.component(YwDatePicker.RangePicker.name, RangePicker);
};
export default YwDatePicker;
